export default __webpack_public_path__ + "static/media/maintenance.9571ea58.svg";